<app-app-nav></app-app-nav>
<app-countdown></app-countdown>
<app-cta></app-cta>
<app-footer [isHome]="true"></app-footer>
